import actions from './actions';
import { exportCommonFile } from "../../../../helpers/utilities";

const initState = {
    gstTransactionLoader: false,
    gstTransactionDetails: '',
    error: '',
};

export default function adminReportReducer(state = initState, action) {
    switch (action.type) {
        case actions.GST_TRANSACTION_DETAILS_START: {
            return {
                ...state,
                gstTransactionLoader: true,
            };
        }
        case actions.GST_TRANSACTION_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                gstTransactionDetails: action.payload,
                gstTransactionLoader: false,
            };
        }
        case actions.GST_TRANSACTION_DETAILS_FAILURE: {
            return {
                ...state,
                gstTransactionLoader: false,
                error: action.message
            };
        }
        case actions.DELIVERY_DETAILS_START: {
            return {
                ...state,
                deliveryLoader: true,
            };
        }
        case actions.DELIVERY_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                deliveryDetails: action.payload,
                deliveryLoader: false,
            };
        }
        case actions.DELIVERY_DETAILS_FAILURE: {
            return {
                ...state,
                deliveryLoader: false
            };
        }
        default:
            return state;
    }
}